import React from 'react';
import { AddIcon, MinusIcon } from '@chakra-ui/icons';
import {
  Accordion as ChakraAccordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
} from '@chakra-ui/react';

import Text from './Text';

const Accordion = ({
  title = '',
  titleTextStyle = 'small2',
  titleStyle,
  buttonStyle,
  children,
  ...props
}) => {
  return (
    <ChakraAccordion
      style={{ borderColor: 'transparent', padding: '0px', margin: 0 }}
      allowToggle
      {...props}
    >
      <AccordionItem style={{ borderWidth: '0px' }}>
        {({ isExpanded }) => (
          <>
            <AccordionButton
              style={{
                padding: 0,
                paddingTop: '16px',
                paddingBottom: '16px',
                backgroundColor: 'transparent',
              }}
              _focus={{ outline: 'none', boxShadow: 'none' }}
            >
              {isExpanded ? (
                <MinusIcon fontSize="12px" style={buttonStyle} />
              ) : (
                <AddIcon fontSize="12px" style={buttonStyle} />
              )}
              <Text ml="10px" textAlign="left" textStyle={titleTextStyle} style={titleStyle}>{title}</Text>
            </AccordionButton>
            <AccordionPanel style={{ padding: 0, marginBottom: isExpanded ? '16px' : 'auto' }}>
              {children}
            </AccordionPanel>
          </>
        )}
      </AccordionItem>
    </ChakraAccordion>
  );
};

export default Accordion;
